/**
 * We need to get experiments where the slugs don't contain ".$"
 * 
 * Relevant issues:
 * https://jira.mongodb.org/browse/JAVA-2810
 * https://jira.mongodb.org/browse/SERVER-30575
 * https://jira.mongodb.org/browse/SERVER-30417
 * 
 * If we were to attempt to solve this on the backend, it would involve custom functionality
 * that would be hard to maintain and not worth the effort.
 * 
 * The front-end will replace "." with "_" before sending experiments with an inquiry.
 * 
 * If these issues are resolved we can get rid of this and just send the experiments directly as before.
 * 
 * @param {Map<string, number>} experiments
 * @returns {Map<string, number>} mongo-safe experiments
 */
function getMongoSafeExperiments(experiments) {
    return [ ...experiments ]
        .reduce(
            (result, [ key, value ]) => {
                const safeKey = key.replace('.', '_');

                result.set(safeKey, value);

                return result;
            },
            new Map(),
        );
}

export default getMongoSafeExperiments;